import ChatBot from '@/components/ChatBot/ChatBot';

export default function ChatBotPage() {
  return (
    <div className="aida-page-root">
      <ChatBot />
    </div>
  );
}
